import styled from '@emotion/styled'
import { Menu } from 'semantic-ui-react'

export const CustomMenu = styled(Menu)([
  {
    border: '0px solid rgba(34,36,38,.15) !important',
    borderRadius: '0 !important',
    height: 43,
    marginBottom: '0 !important',
  },
])
